<template>
  <div
    class="flex items-center gap-5"
    :class="disabled ? 'cursor-not-allowed select-none' : ''"
  >
    <div
      class="flex flex-col"
      :class="disabled ? 'text-gray-400' : 'text-gray-700'"
    >
      <span>{{ title }}</span>
      <span
        v-if="subtitle"
        class="text-xs font-normal"
        :class="{
          italic: disabled,
        }"
      >{{ subtitle }}</span>
    </div>
    <span
      v-if="!disabled"
      class="block rounded border border-slate-300 bg-white px-1 py-0.5 text-xs"
    >{{ themeCount }}</span>
  </div>
</template>

<script>
export default {
  name: 'EsgMetricsTabHeader',

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    count: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      themeCount: this.count,
    }
  },

  watch: {
    count(newCount) {
      this.themeCount = newCount
    },
  },
}
</script>
